import { render, staticRenderFns } from "./RedeemReward.vue?vue&type=template&id=05ded060&scoped=true&"
import script from "./RedeemReward.vue?vue&type=script&lang=ts&"
export * from "./RedeemReward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ded060",
  null
  
)

export default component.exports